if( window.console == null ){
    window.console = {
        log: function (p) {},
    };
}

var 
    _body,
    _window
;

var asn_FN = function (){
    asn = this;
    asn.init();
};

(function($){

    asn_FN.prototype = {
        
        init: function () {

            _body = $( 'body' );
            _window = $( window );
            _vp_width = Utils.getPageWidth();

            // Custom scrolls
            var $scroller = $( '.scroller' );
            if( $scroller.length ){
                
                $scroller.each(function(){

                    this.$ = this.$ || $( this );

                    if( $scroller.css( 'overflow-y' ) === 'auto' ){
                        this.$.mCustomScrollbar({ 
                            axis : 'y',
                            scrollbarPosition : 'outside'
                        });
                    }
                    
                });

            }

            // Dropdown estado
            $( '.dropdown.estado' ).each(function(){

                var $this = $( this );
                var $floater = $this.children( 'nav,ul' );

                $this.children( 'a,button' ).on( 'click', function(e){

                    e.preventDefault();

                    this.$ = this.$ || $( this );
                    
                    var opened = $this.hasClass( 'opened' );
                    if( opened ){
                        $this.trigger( 'close' );
                        $this.removeClass( 'opened' );
                    }
                    else {
                        $this.addClass( 'opened' );
                        $this.trigger( 'open' );
                    }

                });

            });

            asn.bindSearchForm();

            // Função de resize da janela do browser ( Define qual o viewport )
            // asn.resizing();
            // window.onresize = asn.resizing;

            // Control of page scroll
            // asn.scrolling();
            // _window.on( 'scroll', asn.scrolling );

            // Sanfonas
            //asn.bindSanfonas();

            // Footer nav
            //asn.bindFooterNav();

            // General functions
            asn.general();

        },

        // Properties of Class
        properties: {
            timeEffects: 400, // Tempo para os efeitos
            device: 'desktop', // Device default
            scrollTop: 0,
            loading: false,
            userbars: false,
        },

        bindSearchForm: function(){

            var $formSearch = $( 'form.search-filteres' );
            if( !$formSearch.length ) return true;

            var $allFields = $( 'input', $formSearch );
            $( 'input[type="radio"]', $formSearch ).on( 'change', function(){
                $allFields.filter( '[value=""]' ).remove();
                $formSearch.submit();
            });

        },

        // Função de resize da janela do browser ( Define qual o viewport )
        resizing: function () {
            
            var _wWidth = _window.outerWidth();

            // Define qual o viewport
            if( _wWidth < 768 ){
                asn.properties.device = 'smartphone';
            }
            else if ( _wWidth >= 768 && _wWidth <= 1279 ){
                asn.properties.device = 'tablet';
            }
            else { 
                asn.properties.device = 'desktop';
            }

            if ( asn.properties.device === 'desktop' ){
                _body
                    .removeClass( 'tablet' )
                    .removeClass( 'mobile' )
                    .addClass( 'desktop' )
                ;
            } 
            else if( asn.properties.device === 'tablet' ){
                _body
                    .removeClass( 'desktop' )
                    .removeClass( 'mobile' )
                    .addClass( 'tablet' )
                ;
            } 
            else if( asn.properties.device === 'smartphone' ){
                _body
                    .removeClass( 'desktop' )
                    .removeClass( 'tablet' )
                    .addClass( 'mobile' )
                ;
            }
        
        },

        bindIsNotis : function(){

            var $isnotiss = $( '.component-is-not-is' );

            $( '.component-is-not-is ul' ).hover(
                function(){
                    asn.lockScroll();
                },
                function(){
                    asn.unlockScroll();
                }
            );

        },

        bindFooterNav: function bindFooterNav(){

            var $fnav = $( 'footer.navigation' );
            if( !$fnav.length ) return;

            var $links = $( 'a', $fnav );

            $links.hover(
                function(){
                    this.$ = this.$ || $( this );
                    $links.removeClass( 'active' );
                    this.$.addClass( 'active' );
                },
                function(){
                    this.$ = this.$ || $( this );
                   this.$.removeClass( 'active' );
                }
            );

        },

        bindSanfonas : function bindSanfonas(){

            // Informações úteis
            $( '.piki-sanfona' ).pikiSanfona({              
                items: '>div',
                headers: '>header',
                contents: '>div'
            });
        
        },

        // Controla o scroll da página
        scrolling: function( e ){

            var 
                $header = $( 'header' ),
                $nav = $( 'body > nav' )
            ;

            if (
                _window.scrollTop() < asn.properties.scrollTop &&
                _window.scrollTop() > $header.innerHeight() + $header.offset().top
            ){
                $nav.addClass( 'active' );
            } 
            else {
                $nav.removeClass( 'active' );
            }

            // Close userbars
            asn.userBar.close();

            // Keep last scrolltop
            asn.properties.scrollTop = _window.scrollTop();
        
        },

        // Lock scroll
        lockScroll : function(){
            $('html,body').addClass( 'lockscroll' );
        },

        // Unlock scroll
        unlockScroll : function(){
            $('html,body').removeClass( 'lockscroll' );
        },

        // Funções gerais de todo o site
        general: function (){

            // FAQ
            $( '.piki-sanfona' ).pikiSanfona({      
                items: '.sanfona-item',
                headers: '.item-header',
                contents: '.item-content',
                openFirst: false
            });

        }

    };

    $(function () {
        asn = new asn_FN();
    });
  
})(jQuery);
